var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDatentrger = function SvgDatentrger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.481,
    height: 86.371
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.481,
    height: 86.371,
    fill: "#bcc8cc",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M57.881 32.642c0 .4-.01.79-.03 1.18-.01.23-.02.46-.04.68-.01.19-.02.37-.04.55a6 6 0 0 1-.06.57c-.04.36-.08.72-.14 1.07-.063.455-.158.91-.245 1.367-.053.277-.122.55-.19.825-.067.273-.124.545-.215.818a5 5 0 0 1-.15.52q-.09.345-.21.69l-.03.09a26.64 26.64 0 0 1-7.362 11.324 1 1 0 0 0 .693 1.726h5.62a1 1 0 0 1 1 1v19.17a1 1 0 0 1-.29.7l-5.16 5.16a1 1 0 0 1-.7.29h-38.18a1 1 0 0 1-.7-.29l-5.16-5.16a1 1 0 0 1-.29-.7v-32.92a1 1 0 0 0-.05-.3l-.03-.09q-.12-.345-.21-.69a5 5 0 0 1-.15-.52c-.091-.272-.149-.545-.216-.817-.067-.273-.136-.547-.189-.824-.087-.456-.182-.913-.246-1.37-.06-.35-.1-.71-.14-1.07a4 4 0 0 1-.05-.57 5 5 0 0 1-.05-.55c-.02-.22-.03-.45-.04-.68a23 23 0 0 1 0-2.36c.01-.23.02-.46.04-.68a5 5 0 0 1 .05-.55 4 4 0 0 1 .05-.57c.04-.36.08-.72.14-1.07.064-.456.16-.912.246-1.368.053-.278.122-.55.19-.825.066-.272.124-.544.214-.816a5 5 0 0 1 .15-.52q.09-.345.21-.69l.03-.09a1 1 0 0 0 .05-.3v-11.79a1 1 0 0 1 .29-.7l5.2-5.2a1 1 0 0 1 .7-.29h19.05q.6 0 1.2.03c.2.01.41.02.62.04.21.01.43.02.64.05a4 4 0 0 1 .48.05 9 9 0 0 1 .88.11c.52.07 1.03.16 1.54.26q.645.135 1.29.3.63.165 1.26.36c.42.13.83.27 1.24.42a22 22 0 0 1 2.39 1.01 26 26 0 0 1 5.4 3.46 26.7 26.7 0 0 1 5.84 6.75c.22.37.43.74.64 1.12.15.28.3.57.44.86a21 21 0 0 1 1.07 2.45c.09.23.17.46.25.69a3 3 0 0 1 .11.32c.09.25.17.51.24.77a1.3 1.3 0 0 1 .09.3c.08.27.15.54.22.82.09.34.17.69.24 1.04.04.2.08.39.11.59.05.23.09.47.13.71a1 1 0 0 1 .02.18 12 12 0 0 1 .15 1.18.6.6 0 0 1 .02.13c.03.3.05.6.07.9.02.17.02.35.03.53.02.4.03.8.03 1.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M18.555 9.232a26.5 26.5 0 0 0-9.329 8.442.122.122 0 0 1-.225-.067v-4.533a.13.13 0 0 1 .037-.09l3.946-3.945a.13.13 0 0 1 .09-.037h5.425a.122.122 0 0 1 .056.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M31.24 24a8.64 8.64 0 1 0 8.641 8.64 8.65 8.65 0 0 0-8.64-8.64m0 14.28a5.64 5.64 0 1 1 5.641-5.64 5.647 5.647 0 0 1-5.64 5.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M53.481 59.052v13.925a1 1 0 0 1-.293.708l-3.394 3.394a1 1 0 0 1-.707.293h-8.866a1 1 0 0 1-1-1v-9.436a1 1 0 0 1 .293-.707l7.874-7.884a1 1 0 0 1 .708-.293h4.385a1 1 0 0 1 1 1M36.221 67.522v8.85a1 1 0 0 1-1 1H13.395a1 1 0 0 1-.707-.293l-3.394-3.394a1 1 0 0 1-.293-.708V52.574a1.676 1.676 0 0 1 3.033-.985c3.944 5.43 9.577 12.784 10.928 14.543a1 1 0 0 0 .792.39H35.22a1 1 0 0 1 1 1M31.24 9a23.64 23.64 0 1 0 23.641 23.64A23.667 23.667 0 0 0 31.241 9m0 32.28a8.64 8.64 0 1 1 8.641-8.64 8.65 8.65 0 0 1-8.64 8.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.718 19.884-8.814 6.555a10.6 10.6 0 0 0-4.666-3.686l4.139-10.192a21.48 21.48 0 0 1 9.34 7.323M27.23 42.469 23.093 52.66a21.47 21.47 0 0 1-9.085-6.97l8.824-6.552a10.6 10.6 0 0 0 4.4 3.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "m24.777 71.495 19.737-29.138a1.387 1.387 0 1 0-2.054-1.865L15.36 62.944a6.62 6.62 0 1 0 9.418 8.55m-2.192-7.047a2.607 2.607 0 0 1 .386-4.167l.233-.144 11.655-9.656a.303.303 0 0 1 .445.403l-8.488 12.532-.122.246a2.608 2.608 0 0 1-4.11.786"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M16.408 71.25a3.62 3.62 0 1 1 5.115-.247 3.625 3.625 0 0 1-5.115.248"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.482,
    cy: 4,
    fill: "#4c6f73",
    rx: 2,
    ry: 1.995
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.114,
    cy: 4,
    fill: "#4c6f73",
    rx: 2,
    ry: 1.995
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.482,
    cy: 82.366,
    fill: "#4c6f73",
    rx: 2,
    ry: 1.995
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.114,
    cy: 82.366,
    fill: "#4c6f73",
    rx: 2,
    ry: 1.995
  }))));
};
export default SvgDatentrger;